<script>
	const model = require('model/model');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const BUTTER_BAR_DISMISSED = analyticsUtilities.events.BUTTER_BAR_DISMISSED;

	module.exports = {
		props: {
			dismissKey: {
				default: null
			},
			eventData: {
				default: undefined
			}
		},
		components: {
			'x-icon': require('components/svg/x-icon.vue').default
		},
		computed: {
			dismissable() {
				let dismissKey = this.dismissKey;
				return dismissKey !== null;
			}
		},
		data() {
			return {
				isDismissed: null
			};
		},
		methods: {
			onDismiss() {
				model.set(this.dismissKey, true);
				this.isDismissed = true;
				fireEvent(BUTTER_BAR_DISMISSED, this.eventData);
			}
		},
		mounted() {
			let dismissKey = this.dismissKey;

			if (dismissKey) {
				this.isDismissed = model.get(dismissKey);
				this.$watchModel(dismissKey, value => (this.isDismissed = value));
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.butter-bar-promo.butter-bar {
		position: relative;

		&.dismissable {
			padding-right: 1.75rem;
		}

		.butter-bar-dismiss {
			position: absolute;
			top: 0.25rem;
			right: 0.5rem;

			&:hover {
				color: $c-blue-dark;
			}

			.x-icon {
				width: 0.75rem;
				height: 0.75rem;
			}
		}

		.button.-link-standard {
			color: $c-blue-dark;

			&:hover {
				color: $c-slate-dark;
			}
		}
	}
</style>
<template>
	<div
		class="butter-bar butter-bar-promo"
		:class="{ dismissable }"
		:hidden="isDismissed"
		role="note">
		<button
			v-if="dismissable"
			class="butter-bar-dismiss button -link"
			type="button"
			aria-label="Dismiss note"
			@click="onDismiss">
			<x-icon></x-icon>
		</button>
		<slot></slot>
	</div>
</template>
